import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const footerSections = [
    {
      title: 'Services',
      links: [
        { label: 'Web Development', action: () => scrollToSection('web-development') },
        { label: 'Mobile Apps', action: () => scrollToSection('mobile-development') },
        { label: 'Legacy Systems', action: () => scrollToSection('other-development') },
        { label: 'Consulting', action: () => scrollToSection('contact') }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', action: () => scrollToSection('about') },
        { label: 'Portfolio', action: () => scrollToSection('portfolio') },
        { label: 'Contact', action: () => scrollToSection('contact') }
      ]
    }
  ];

  const linkedinUrl = 'https://www.linkedin.com/in/ihedroj';

  return (
    <footer className="footer">
      <div className="container">
        <motion.div 
          className="footer-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <motion.div 
              className="footer-logo"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i className="fas fa-code"></i>
              <span>Top Most Systems</span>
            </motion.div>
            <p>Business websites, mobile apps, and production software for companies.</p>
            <p className="footer-founder">
              Ihab R. Hedroj, Founder
            </p>
            <a
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-linkedin"
            >
              <i className="fab fa-linkedin"></i>
              LinkedIn portfolio
            </a>
          </motion.div>

          {footerSections.map((section, sectionIndex) => (
            <motion.div 
              key={sectionIndex}
              className="footer-section"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 + sectionIndex * 0.1 }}
              viewport={{ once: true }}
            >
              <h3>{section.title}</h3>
              <ul>
                {section.links.map((link, linkIndex) => (
                  <motion.li 
                    key={linkIndex}
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <button
                      onClick={link.action}
                      className="footer-link"
                    >
                      {link.label}
                    </button>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <p>&copy; {new Date().getFullYear()} Top Most Systems. All rights reserved.</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;


